import { QueryHookOptions } from '@apollo/client';
import { useCustomQuery } from '../../../../logic/api/graphQL/useCustomQuery';
import gql from 'graphql-tag';
import { RankIntervalInputGq } from '../../models/RankIntervalInputGq';

export function useGetRankIntervalsGq(
  command: CommandGq,
  options: QueryHookOptions<DataGq, Variables> = {}
) {
  const query = useCustomQuery<DataGq, Variables>(gqTag, {
    ...options,
    variables: { command },
  });

  return {
    query,
    result: (query?.data ?? query?.previousData)?.projects?.getRankIntervals,
  };
}

const gqTag = gql`
  query GetRankIntervals($command: GetRankIntervalsCommand!) {
    projects {
      getRankIntervals(command: $command) {
        intervalAnalyses {
          keywordCount
          projectId
          searchVolume
          searchTraffic
          startRank
          endRank
        }
      }
    }
  }
`;

interface DataGq {
  readonly projects: {
    readonly getRankIntervals: ResponseGq;
  };
}

export interface ResponseGq {
  readonly intervalAnalyses: IntervalAnalysisGq[];
}

export interface IntervalAnalysisGq {
  readonly keywordCount: number;
  readonly projectId: number;
  readonly searchVolume: number;
  readonly searchTraffic: number;
  readonly startRank?: number;
  readonly endRank?: number;
}

export interface Variables {
  readonly command: CommandGq;
}

export interface CommandGq {
  readonly projectId: number;
  readonly childProjectIds?: number[];
  readonly projectDomainId?: number;
  readonly rankIntervals: RankIntervalInputGq[];
  readonly tagGroupId: number;
  readonly tagId: number;
}
